import { useQuery } from '@apollo/client';
import { EllipsisLoader, palettes, Tag, Tooltip } from '@indigo-ag/component-module';
import { MatriculaTerritoryStatusQuery } from '@indigo-ag/schema';
import { getMatriculaHasTerritory } from 'features/brazil-grower/queries';
import React from 'react';
import i18next from 'i18next';

interface VegaIntegrationStatusProps {
  matriculaId: string;
}

const RENDER_COMPONENT_MAP: { [key in MatriculaTerritoryStatusQuery]: JSX.Element } = {
  DOES_NOT_HAVE_TERRITORY: <Tag label={i18next.t('vegaMatriculaHasTerritory-warning')} variant="error" />,
  HAS_TERRITORY: <Tag label={i18next.t('vegaMatriculaHasTerritory-success')} variant="success" />,
  QUERY_FAILED: <Tag label={i18next.t('vegaMatriculaHasTerritory-error')} variant="error" />
};

const TOOLTIP_TITLE_MAP: { [key in MatriculaTerritoryStatusQuery]: string } = {
  DOES_NOT_HAVE_TERRITORY: i18next.t('vegaMatriculaHasTerritory-warning-tooltip'),
  HAS_TERRITORY: i18next.t('vegaMatriculaHasTerritory-success-tooltip'),
  QUERY_FAILED: i18next.t('vegaMatriculaHasTerritory-error-tooltip')
};

const VegaIntegrationStatus = ({ matriculaId }: VegaIntegrationStatusProps) => {
  const { data, loading } = useQuery<{ matriculaHasTerritory: MatriculaTerritoryStatusQuery }>(
    getMatriculaHasTerritory,
    {
      variables: { matriculaNumber: matriculaId },
      skip: !matriculaId
    }
  );

  const status = data?.matriculaHasTerritory ?? MatriculaTerritoryStatusQuery.QUERY_FAILED;

  return loading ? (
    <EllipsisLoader style={{ width: 30 }} fontSize={15} color={palettes.brand.blue.base} />
  ) : (
    <Tooltip title={TOOLTIP_TITLE_MAP[status]} placement="top-start">
      {RENDER_COMPONENT_MAP[status]}
    </Tooltip>
  );
};

export default VegaIntegrationStatus;
